<div class="container">
    <div class="row fields-container" [formGroup]="missedCallSettingsForm">
        <mat-form-field class="w-50 no-margin" appearance="outline">
            <mat-label>{{labelValue}}</mat-label>
            <input matInput type="number" placeholder="Set your custom after-call text message"
                formControlName="callbackScheduledAt">
        </mat-form-field>
        <mat-form-field class="w-50 no-margin" appearance="outline">
            <mat-label>The unit of time.</mat-label>
            <mat-select formControlName="timeUnit">
                <mat-option [value]="unit" *ngFor="let unit of timeUnits">{{unit}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>